module.exports = __webpack_public_path__ + "img/141.64599d0e.jpg";